import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { io, Socket } from 'socket.io-client';
import { IUser, IUserToken } from '@app/models/user';
import { SocketActions } from '@app/modules/client/constant';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  socket!: Socket;
  user!: IUser;
  domain: string;

  constructor() {
    this.domain = window.location.hostname;
  }

  // Connect socket
  connectSocket(user: IUser, token: IUserToken) {
    if (!user?.id || !token?.id) return;

    this.user = user;
    const coreApi: string = environment.api.core.uri;

    if (!this.socket || !this.socket.connected) {
      this.socket = io(coreApi, {
        path: '/wss',
        transports: ['websocket'],
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 2000,
        auth: { token: token.id },
      });

      this.socket.on('connect', () => console.log('Connected:', this.socket.id));
      this.socket.on('connect_error', err => console.error('Connect error:', err.message));
      this.socket.on('disconnect', reason => console.warn('Disconnected:', reason));
      this.socket.on('error', err => console.error('Socket error:', err));
    }
  }

  // Publish message
  publishMessage(eventName: string, message: string) {
    if (this.socket?.connected) {
      const topic: string = this.getTopicName(eventName);
      this.socket.emit('message', {
        action: SocketActions.Publish,
        channel: [topic],
        message,
      });
    }
  }

  // Subscribe to events
  subscribeSocketEvent(eventName: string): Observable<any> {
    return new Observable(observer => {
      const topic: string = this.getTopicName(eventName);

      const listener = (response: any) => {
        if (response.channel === topic) observer.next(response.data);
      };

      this.socket.on('message', listener);

      // Send subscription
      this.socket.emit('message', { action: SocketActions.Subscribe, channels: [topic] });

      return () => {
        this.socket.off('message', listener);
        this.unsubscribeSocketEvent(eventName);
      };
    });
  }

  // Unsubscribe
  unsubscribeSocketEvent(eventName: string) {
    const topic: string = this.getTopicName(eventName);
    this.socket.emit('message', { action: SocketActions.Unsubscribe, channels: [topic] });
  }

  // Disconnect
  disconnect() {
    if (this.socket?.connected) {
      this.socket.disconnect();
    }
  }

  // Generate topic name
  private getTopicName(eventName: string) {
    return `org.ecms.${eventName}.${this.user.customerId}.${this.user.id}`;
  }
}
